import { HelpIcon } from "@icons/help-icon"
import { Tooltip } from "@mui/material"
import type { ReactNode } from "react"

export function HintTooltip({ title }: { title: string | ReactNode }) {
	return (
		<Tooltip placement="right-start" title={title}>
			<span className="help-icon">
				<HelpIcon />
			</span>
		</Tooltip>
	)
}
